/**
 * Chatbot Options & Constants
 *
 * Centralizes all option arrays used by the chatbot,
 * keeping useChatbotWeb.js focused on logic and state.
 */

// ─── Menu Principal ───────────────────────────────────────────────────────────

export const defaultOptions = [
    { key: 'comunicacao_interna_interacao', label: 'Comunicação Interna' },
    { key: 'voltar_chat', label: 'Tirar duvidas com a ISA' },
    { key: 'envio_de_atestados', label: 'Informar ausência' },
    { key: 'holerite', label: 'Gerar holerite' },
    { key: 'informe', label: 'Gerar informe de rendimento' },
    { key: 'emprestimo', label: 'Fazer empréstimo - Módulo em TESTE' },
    { key: 'encerrar_chat', label: 'Encerrar o Chat' },
];

export const defaultOptionsNew = [{ key: 'envio_de_atestados', label: 'Informar uma ausência' }];

// ─── Submenu: Informações Gerais ──────────────────────────────────────────────

export const optionsSubInformacoesGerais = [
    { key: 'canal_de_denuncia', label: 'Canal de Denuncia' },
    { key: 'encerrar_chat', label: 'Encerrar o Chat' },
];

// ─── Submenu: Manuais e Tutoriais ─────────────────────────────────────────────

export const optionsManuaisTutoriais = [
    { key: 'registro_mobile_ajuste_ponto', label: 'Registro Mobile e Ajuste de Ponto' },
    { key: 'busca_biometria_nuvem', label: 'Busca de Biometria em Nuvem' },
    { key: 'primeiro_acesso_app_altum', label: 'Primeiro Acesso App Altum' },
    { key: 'encerrar_chat', label: 'Encerrar o Chat' },
];

// ─── Status List ──────────────────────────────────────────────────────────────

export const statusList = [
    { key: '', label: 'Todos os Status' },
    { key: 'PENDENTE', label: 'Pendente' },
    { key: 'PENDENTE_HUMANO', label: 'Atendimento em andamento' },
    { key: 'FINALIZADO', label: 'Finalizado' },
    { key: 'FINALIZADO_HUMANO', label: 'Atendimento finalizado' },
    { key: 'RESOLVIDO', label: 'Resolvido' },
    { key: 'RESOLVIDO_HUMANO', label: 'Atendimento Resolvido' },
    { key: 'NAO_RESOLVIDO', label: 'Não Resolvido' },
    { key: 'NAO_RESOLVIDO_HUMANO', label: 'Atendimento Não Resolvido' },
    { key: 'CANCELADO', label: 'Cancelado' },
    { key: 'AGUARDANDO_HUMANDO', label: 'Aguardando Atendente' },

    // Ausência
    { key: 'AUSENCIA_PENDENTE', label: 'Auto atendimento sobre ausência em andamento' },
    { key: 'ATENDIMENTO_AUSENCIA_PENDENTE', label: 'Atendimento sobre ausência pendente' },
    { key: 'ATENDIMENTO_AUSENCIA_EM_ANDAMENTO', label: 'Atendimento sobre ausência em andamento' },
    { key: 'ATENDIMENTO_AUSENCIA_CANCELADO', label: 'Atendimento sobre ausência cancelado' },
    { key: 'ATENDIMENTO_AUSENCIA_CONCLUIDO', label: 'Atendimento sobre ausência concluído' },
    { key: 'AUSENCIA_FINALIZADA', label: 'Ausência finalizada' },
    { key: 'AUSENCIA_EMERGENCIAL', label: 'Ausência emergencial' },
    { key: 'AUSENCIA_URGENTE', label: 'Ausência urgente' },
    { key: 'AUSENCIA_PROGRAMADA', label: 'Ausência programada' },
    { key: 'AUSENCIA_CANCELADA', label: 'Ausência cancelada' },
    { key: 'AUSENCIA_EM_FINALIZACAO', label: 'Ausência em processo de finalização' },

    // Comunicação Interna
    { key: 'COMUNICACAO_RESPONSAVEL_PENDENTE', label: 'Comunicação aguardando atendimento' },
    { key: 'COMUNICACAO_AT_HUMANDO', label: 'Comunicação interna em atendimento' },
    { key: 'COMUNICACAO_PENDENTE', label: 'Comunicação interna pendente' },
    { key: 'COMUNICACAO_CANCELADO', label: 'Comunicação interna cancelada' },
    { key: 'COMUNICACAO_EM_ANDAMENTO', label: 'Comunicação interna em andamento' },
    { key: 'COMUNICACAO_FIN_HUMANDO', label: 'Comunicação finalizada pelo atendente' },
    { key: 'COMUNICACAO_N_RES_HUMANDO', label: 'Comunicação não resolvida pelo atendente' },
    { key: 'COMUNICACAO_ANDAMENTO_INTERACAO', label: 'Iniciou a comunicação interna' },
    { key: 'COMUNICACAO_ANDAMENTO_AREA', label: 'Comunicação Interna - Preenchendo a Area' },
    { key: 'COMUNICACAO_ANDAMENTO_TIPO', label: 'Comunicação Interna - Preenchendo a Tipo' },
    { key: 'COMUNICACAO_ANDAMENTO_D_INICIAL', label: 'Comunicação Interna - Data Inicial Atestados' },
    { key: 'COMUNICACAO_ANDAMENTO_D_FINAL', label: 'Comunicação Interna - Enviando Data Final Atestados' },
    { key: 'COMUNICACAO_ANDAMENTO_CID', label: 'Comunicação Interna - Cid' },
    { key: 'COMUNICACAO_ANDAMENTO_COMENTARIO', label: 'Comunicação Interna - Registrando Comentário' },
    { key: 'COMUNICACAO_ANDAMENTO_D_INICIAL_ALL', label: 'Comunicação Interna - Enviando Data Inícial' },
    { key: 'COMUNICACAO_ANDAMENTO_D_FINAL_ALL', label: 'Comunicação Interna - Enviando Data Final' },
    { key: 'COMUNICACAO_ANDAMENTO_REGIONAL', label: 'Comunicação Interna - Selecionando Regional' },
    { key: 'COMUNICACAO_ANDAMENTO_ARQUIVO', label: 'Comunicação Interna - Enviando arquivo' },
    { key: 'COMUNICACAO_ANDAMENTO_DASHBOARD', label: 'Comunicação Interna - Em andamento Sagris' },
    { key: 'COMUNICACAO_CONCLUIDO_DASHBOARD', label: 'Comunicação Interna - Concluído Sagris' },
    { key: 'COMUNICACAO_RECUSADO_DASHBOARD', label: 'Comunicação Interna - Recusado Sagris' },

    // Empréstimo
    { key: 'PENDENTE_EMPRESTIMO', label: 'Empréstimo pendente' },
    { key: 'EMPRESTIMO_FINALIZADO', label: 'Empréstimo finalizado' },
    { key: 'EMPRESTIMO_PEND_ATEND', label: 'Empréstimo pendente atendimento' },
    { key: 'EMPRESTIMO_EM_ATEND', label: 'Empréstimo em atendimento' },
    { key: 'EMPRESTIMO_FIN_ATEND', label: 'Empréstimo finalizado atendimento' },
];

// ─── Finalização de Chat (Bot) ────────────────────────────────────────────────

export const finalizar = [
    { key: 'problema_resolvido', label: 'Sim' },
    { key: 'problema_nao_resolvido', label: 'Não' },
    { key: 'voltar_chat', label: 'Tentar resolver novamente' },
    { key: 'call_human', label: 'Chamar um atendente' },
    { key: 'finalizar', label: 'Tentar resolver mais tarde' },
];

export const finalizarIsa = [
    { key: 'problema_resolvido', label: 'Resolvi o problema' },
    { key: 'problema_nao_resolvido', label: 'Não consegui resolver o problema' },
    { key: 'call_human', label: 'Chamar um atendente' },
];

// ─── Finalização de Atendimento Humano ────────────────────────────────────────

export const finalizarAtendimento = [
    { key: 'problema_resolvido_atendimento', label: 'Sim' },
    { key: 'problema_nao_resolvido_atendimento', label: 'Não' },
    { key: 'cancelar_atendimento', label: 'Cancelar atendimento' },
    {
        key: 'voltar_pendente_atendimento',
        label: 'Voltar como pendente e deixar outro atendente resolver',
    }, // PENDENTE_HUMANO
    { key: 'finalizar', label: 'Tentar resolver mais tarde' },
];

// ─── Empréstimo ───────────────────────────────────────────────────────────────

export const optionsEmprestimo = [{ key: 'emprestimo_inicio', label: 'Iniciar a simulação' }];

export const emprestimoTodasOpcoes = [
    { key: 'emprestimo_inicio', label: 'Iniciar a simulação' },
    { key: 'credito_consignado', label: 'Crédito Consignado' },
    { key: 'credito_calcular_simulacao', label: 'Calcular Simulação' },
    { key: 'credito_valor_total_calcular_simulacao', label: 'Calcular Simulação com Valor Total' },
    { key: 'emprestimo_continuar', label: 'Continuar a simulação' },
    { key: 'credito_salvar_simulacao', label: 'Salvando os dados da proposta' },
    { key: 'emprestimo_abrir_janela_atualizacao', label: 'Atualizar dados cadastrais' },
    { key: 'credito_consignado_aprovada_aderir_proposta', label: 'Aderir Proposta' },
    { key: 'credito_consignado_averbada', label: 'Ver status do meu empréstimo' },
    { key: 'credito_consignado_efetivada', label: 'Ver status do meu empréstimo' },
];

// ─── Comunicação Interna ──────────────────────────────────────────────────────

export const optionsComunicacaoInternaTodasOpcoes = [
    { key: 'iniciar_comunicacao_interna', label: 'Iniciar a Comunicação Interna' },
    { key: 'area_comunicacao_interna', label: 'Area' },
    { key: 'tipo_comunicacao_interna', label: 'Tipo' },
    { key: 'regional_comunicacao_interna', label: 'Regional' },
    { key: 'data_inicio_comunicacao_interna', label: 'Data Inicio' },
    { key: 'data_fim_comunicacao_interna', label: 'Data Fim' },
    { key: 'cid_comunicacao_interna', label: 'Cid' },
    { key: 'comentario_comunicacao_interna', label: 'Comentario' },
    { key: 'arquivo_comunicacao_interna', label: 'Arquivo' },
    { key: 'fim_comunicacao_interna', label: 'Fim Comunicação Interna' },
];

export const optionsComunicacaoInternaAreaAtestados = [
    { key: 'comunicacao_interna_interacao_atestado_medico', label: 'Atestado Médico' },
    {
        key: 'comunicacao_interna_interacao_declaracao_comparecimento',
        label: 'Declaração de Comparecimento',
    },
    { key: 'comunicacao_interna_interacao_area', label: 'Mudar a Area' },
];

export const optionsComunicacaoInternaAreaDocumentos = [
    { key: 'comunicacao_interna_interacao_atestado_medico', label: 'Atestado Médico' },
    { key: 'comunicacao_interna_interacao_comprovante_pagamento', label: 'Comprovante de pagamento' },
    { key: 'comunicacao_interna_interacao_area', label: 'Mudar a Area' },
];

export const optionsComunicacaoInternaAreaValeAlimentacao = [
    { key: 'comunicacao_interna_interacao_cesta_basica', label: 'Cesta Básica' },
    { key: 'comunicacao_interna_interacao_vale_alimentacao', label: 'Vale Alimentação' },
    { key: 'comunicacao_interna_interacao_vale_refeicao', label: 'Vale Refeição' },
    { key: 'comunicacao_interna_interacao_area', label: 'Mudar a Area' },
];

export const optionsComunicacaoInternaAreaValeTransporte = [
    { key: 'comunicacao_interna_interacao_vale_transporte', label: 'Vale Transporte' },
    { key: 'comunicacao_interna_interacao_area', label: 'Mudar a Area' },
];

export const optionsComunicacaoInternaAreaVRAuto = [
    {
        key: 'comunicacao_interna_interacao_vr_auto',
        label: 'Vale Refeição/Vale Alimentação',
    },
    { key: 'comunicacao_interna_interacao_area', label: 'Mudar a Area' },
];

export const optionsComunicacaoInternaAreaVR = [
    {
        key: 'comunicacao_interna_interacao_vale_refeicao_vale_alimentacao',
        label: 'Vale Refeição/Vale Alimentação',
    },
    { key: 'comunicacao_interna_interacao_area', label: 'Mudar a Area' },
];

// ─── Ausência ─────────────────────────────────────────────────────────────────

/*
export const ausenciaDefault = [
    { key: 'ausencia_contrato_mensal_sim', label: 'Sim' },
    { key: 'ausencia_contrato_mensal_nao', label: 'Não' },
    { key: 'voltar_chat', label: 'Desistir de abrir ausencia' },
];
*/

export const ausenciaDefault = [
    { key: 'ausencia_contrato_mensal_sim', label: 'Tentar informar ausência novamente' },
    { key: 'voltar_chat', label: 'Desistir de informar ausência' },
];

export const atendimentoOptions = [
    { key: 'comunicacao_interna_interacao', label: 'Não consegui resolver o problema' },
    { key: 'problema_resolvido', label: 'Consegui resolver o problema' },
];
